<template>
  <aside class="admin-sidebar" :class="{ collapsed: appStore.isSidebarCollapsed, 'mobile-open': appStore.isMobileSidebarOpen }">
    <div class="sidebar-header">
      <router-link to="/admin" class="sidebar-logo">
        <img src="/img/favicon-32x32.png" alt="DZ" />
        <span v-if="!appStore.isSidebarCollapsed || appStore.isMobileSidebarOpen">Dury zehin</span>
      </router-link>
      <button
        v-if="appStore.isMobileSidebarOpen"
        type="button"
        class="sidebar-close-btn"
        title="Ýap"
        @click="appStore.closeMobileSidebar"
      >
        <el-icon><Close /></el-icon>
      </button>
    </div>

    <div class="sidebar-scroll">
      <el-menu
        :default-active="activeMenu"
        :collapse="appStore.isSidebarCollapsed && !appStore.isMobileSidebarOpen"
        :collapse-transition="false"
        :unique-opened="true"
        @select="handleMenuSelect"
        class="dz-sidebar-menu"
      >
        <!-- ==================== TEACHER VIEW ==================== -->
        <template v-if="authStore.isTeacher">
          <el-menu-item index="/admin/classes">
            <el-icon><Tickets /></el-icon>
            <template #title>{{ t('menu.classes') }}</template>
          </el-menu-item>
        </template>

        <!-- ==================== RECEPTION VIEW ==================== -->
        <template v-else-if="authStore.isReception">
          <!-- 1. Doglan günleri -->
          <el-menu-item index="/admin/dashboard/birthday">
            <el-icon><Calendar /></el-icon>
            <template #title>{{ t('menu.birthdays') }}</template>
          </el-menu-item>

          <!-- 2. Esasy (Only Classes) -->
          <el-sub-menu index="general">
            <template #title>
              <el-icon><School /></el-icon>
              <span>{{ t('menu.main') }}</span>
            </template>
            <el-menu-item index="/admin/classes">
              <el-icon><Tickets /></el-icon>
              <template #title>{{ t('menu.classes') }}</template>
            </el-menu-item>
          </el-sub-menu>

          <!-- 3. Talyplar (Students) -->
          <el-sub-menu index="students-menu">
            <template #title>
              <el-icon><User /></el-icon>
              <span>{{ t('menu.students') }}</span>
            </template>
            <el-menu-item index="/admin/students">
              <el-icon><List /></el-icon>
              <template #title>{{ t('menu.allStudents') }}</template>
            </el-menu-item>
          </el-sub-menu>

          <!-- 4. Tölegler (Only Invoices) -->
          <el-sub-menu index="invoices-menu">
            <template #title>
              <el-icon><CreditCard /></el-icon>
              <span>{{ t('menu.invoicesMenu') }}</span>
            </template>
            <el-menu-item index="/admin/invoices">
              <el-icon><Money /></el-icon>
              <template #title>{{ t('menu.invoices') }}</template>
            </el-menu-item>
          </el-sub-menu>

          <!-- 5. Hasabatlar (Only Daily Invoices) -->
          <el-sub-menu index="reports-menu">
            <template #title>
              <el-icon><PieChart /></el-icon>
              <span>{{ t('menu.reports') }}</span>
            </template>
            <el-menu-item index="/admin/reports/invoices">
              <el-icon><Document /></el-icon>
              <template #title>{{ t('menu.dailyInvoicesReport') }}</template>
            </el-menu-item>
            <el-menu-item index="/admin/reports/unpaid-students">
              <el-icon><List /></el-icon>
              <template #title>{{ t('menu.unpaidStudentsReport') }}</template>
            </el-menu-item>
          </el-sub-menu>

          <!-- 6. SMS Merkezi -->
          <el-menu-item index="/admin/sms">
            <el-icon><ChatDotRound /></el-icon>
            <template #title>SMS Merkezi</template>
          </el-menu-item>
        </template>

        <!-- ==================== ADMIN & FULL STAFF VIEW ==================== -->
        <template v-else>
          <!-- 1. Main / General (Esasy) -->
          <el-sub-menu v-if="authStore.can('ClassesView') || authStore.can('ReferenceView')" index="general">
            <template #title>
              <el-icon><School /></el-icon>
              <span>{{ t('menu.main') }}</span>
            </template>
            <el-menu-item v-if="authStore.can('ClassesView')" index="/admin/classes">
              <el-icon><Tickets /></el-icon>
              <template #title>{{ t('menu.classes') }}</template>
            </el-menu-item>
            <el-menu-item v-if="authStore.can('ReferenceView')" index="/admin/stages">
              <el-icon><Calendar /></el-icon>
              <template #title>{{ t('menu.stages') }}</template>
            </el-menu-item>
            <el-menu-item v-if="authStore.can('ReferenceView')" index="/admin/shifts">
              <el-icon><Clock /></el-icon>
              <template #title>{{ t('menu.shifts') }}</template>
            </el-menu-item>
            <el-menu-item v-if="authStore.can('ReferenceView')" index="/admin/branches">
              <el-icon><OfficeBuilding /></el-icon>
              <template #title>{{ t('menu.branches') }}</template>
            </el-menu-item>
            <el-menu-item v-if="authStore.can('ReferenceView')" index="/admin/rooms">
              <el-icon><House /></el-icon>
              <template #title>{{ t('menu.rooms') }}</template>
            </el-menu-item>
            <el-menu-item v-if="authStore.can('ReferenceView')" index="/admin/categories">
              <el-icon><CollectionTag /></el-icon>
              <template #title>{{ t('menu.categories') }}</template>
            </el-menu-item>
            <el-menu-item v-if="authStore.can('ReferenceView')" index="/admin/subjects">
              <el-icon><Notebook /></el-icon>
              <template #title>{{ t('menu.subjects') }}</template>
            </el-menu-item>
            <el-menu-item v-if="authStore.can('ReferenceView')" index="/admin/relatives">
              <el-icon><UserFilled /></el-icon>
              <template #title>{{ t('menu.relatives') }}</template>
            </el-menu-item>
          </el-sub-menu>

          <!-- 2. Administration (Administrator) -->
          <el-sub-menu v-if="authStore.can('UsersManage')" index="admin-system">
            <template #title>
              <el-icon><Setting /></el-icon>
              <span>{{ t('menu.administration') }}</span>
            </template>
            <el-menu-item index="/admin/users">
              <el-icon><User /></el-icon>
              <template #title>{{ t('menu.adminUsers') }}</template>
            </el-menu-item>
            <el-menu-item index="/admin/roles">
              <el-icon><Key /></el-icon>
              <template #title>{{ t('menu.roles') }}</template>
            </el-menu-item>
            <el-menu-item index="/admin/asctimetables">
              <el-icon><Upload /></el-icon>
              <template #title>AscTimetable</template>
            </el-menu-item>
          </el-sub-menu>

          <!-- 3. Dcoin -->
          <el-menu-item v-if="authStore.can('DcoinView') || authStore.can('DcoinAllocate')" index="/admin/dcoin">
            <el-icon><Coin /></el-icon>
            <template #title>{{ t('menu.dcoin') }}</template>
          </el-menu-item>

          <!-- 4. CMS / Site Content (Web saýt) -->
          <el-sub-menu v-if="authStore.can('SiteContent')" index="cms-menu">
            <template #title>
              <el-icon><Compass /></el-icon>
              <span>{{ t('menu.cms') }}</span>
            </template>
            <el-menu-item index="/admin/cms/hero">
              <el-icon><Picture /></el-icon>
              <template #title>{{ t('menu.banners') }}</template>
            </el-menu-item>
            <el-menu-item index="/admin/cms/gallery">
              <el-icon><Camera /></el-icon>
              <template #title>{{ t('menu.gallery') }}</template>
            </el-menu-item>
            <el-menu-item index="/admin/cms/siteevents">
              <el-icon><Calendar /></el-icon>
              <template #title>{{ t('menu.siteEvents') }}</template>
            </el-menu-item>
            <el-menu-item index="/admin/cms/eventregistrations?type=Event">
              <el-icon><DocumentChecked /></el-icon>
              <template #title>
                <div class="menu-item-with-badge">
                  <span>{{ t('menu.eventRegistrations') }}</span>
                  <el-badge
                    v-if="authStore.counters.unreadEventRegs > 0"
                    :value="authStore.counters.unreadEventRegs"
                    type="warning"
                  />
                </div>
              </template>
            </el-menu-item>
            <el-menu-item index="/admin/cms/eventregistrations?type=SummerCamp">
              <el-icon><Sunny /></el-icon>
              <template #title>
                <div class="menu-item-with-badge">
                  <span>{{ t('menu.summerCamp') }}</span>
                  <el-badge
                    v-if="authStore.counters.unreadCampRegs > 0"
                    :value="authStore.counters.unreadCampRegs"
                    type="warning"
                  />
                </div>
              </template>
            </el-menu-item>
            <el-menu-item index="/admin/cms/blog">
              <el-icon><EditPen /></el-icon>
              <template #title>{{ t('menu.blog') }}</template>
            </el-menu-item>
            <el-menu-item index="/admin/cms/comments">
              <el-icon><ChatDotRound /></el-icon>
              <template #title>
                <div class="menu-item-with-badge">
                  <span>{{ t('menu.comments') }}</span>
                  <el-badge
                    v-if="authStore.counters.pendingComments > 0"
                    :value="authStore.counters.pendingComments"
                    type="danger"
                  />
                </div>
              </template>
            </el-menu-item>
            <el-menu-item index="/admin/cms/feedback">
              <el-icon><Message /></el-icon>
              <template #title>
                <div class="menu-item-with-badge">
                  <span>{{ t('menu.feedback') }}</span>
                  <el-badge
                    v-if="authStore.counters.unreadFeedback > 0"
                    :value="authStore.counters.unreadFeedback"
                    type="warning"
                  />
                </div>
              </template>
            </el-menu-item>
            <el-menu-item index="/admin/cms/testresults">
              <el-icon><DataAnalysis /></el-icon>
              <template #title>{{ t('menu.testResults') }}</template>
            </el-menu-item>
            <el-menu-item index="/admin/cms/videos">
              <el-icon><VideoCamera /></el-icon>
              <template #title>{{ t('menu.videos') }}</template>
            </el-menu-item>
            <el-menu-item v-if="authStore.can('AdminOnly')" index="/admin/cms/localization">
              <el-icon><Document /></el-icon>
              <template #title>{{ t('menu.localization') }}</template>
            </el-menu-item>
            <el-menu-item index="open-site">
              <el-icon><View /></el-icon>
              <template #title>{{ t('topbar.site') }}</template>
            </el-menu-item>
          </el-sub-menu>

          <!-- 5. Students (Talyplar) -->
          <el-sub-menu v-if="authStore.can('StudentsView')" index="students-menu">
            <template #title>
              <el-icon><User /></el-icon>
              <span>{{ t('menu.students') }}</span>
            </template>
            <el-menu-item index="/admin/students">
              <el-icon><List /></el-icon>
              <template #title>{{ t('menu.allStudents') }}</template>
            </el-menu-item>
          </el-sub-menu>

          <!-- 6. Invoices (Tölegler) -->
          <el-sub-menu v-if="authStore.can('InvoicesView')" index="invoices-menu">
            <template #title>
              <el-icon><CreditCard /></el-icon>
              <span>{{ t('menu.invoicesMenu') }}</span>
            </template>
            <el-menu-item index="/admin/invoices">
              <el-icon><Money /></el-icon>
              <template #title>{{ t('menu.invoices') }}</template>
            </el-menu-item>
            <el-menu-item index="/admin/invoices/prices">
              <el-icon><PriceTag /></el-icon>
              <template #title>{{ t('menu.prices') }}</template>
            </el-menu-item>
          </el-sub-menu>

          <!-- 7. Reports (Hasabatlar) -->
          <el-sub-menu v-if="authStore.can('InvoicesView')" index="reports-menu">
            <template #title>
              <el-icon><PieChart /></el-icon>
              <span>{{ t('menu.reports') }}</span>
            </template>
            <el-menu-item v-if="authStore.isAdmin" index="/admin/reports/general">
              <el-icon><PieChart /></el-icon>
              <template #title>{{ t('menu.generalReport') }}</template>
            </el-menu-item>
            <el-menu-item v-if="authStore.isAdmin" index="/admin/reports/books">
              <el-icon><Notebook /></el-icon>
              <template #title>{{ t('menu.booksReport') }}</template>
            </el-menu-item>
            <el-menu-item v-if="authStore.isAdmin" index="/admin/reports/attendances">
              <el-icon><Check /></el-icon>
              <template #title>{{ t('menu.attendancesReport') }}</template>
            </el-menu-item>
            <el-menu-item v-if="authStore.isAdmin" index="/admin/reports/performance">
              <el-icon><Trophy /></el-icon>
              <template #title>{{ t('menu.performanceReport') }}</template>
            </el-menu-item>
            <el-menu-item v-if="authStore.isAdmin" index="/admin/reports/stages">
              <el-icon><TrendCharts /></el-icon>
              <template #title>{{ t('menu.stagesReport') }}</template>
            </el-menu-item>
            <el-menu-item v-if="authStore.isAdmin" index="/admin/reports/salaries">
              <el-icon><Money /></el-icon>
              <template #title>{{ t('menu.salariesReport') }}</template>
            </el-menu-item>
            <el-menu-item v-if="authStore.isAdmin" index="/admin/reports/duplicate-cards">
              <el-icon><CopyDocument /></el-icon>
              <template #title>{{ t('menu.duplicateCardsReport') }}</template>
            </el-menu-item>
            <el-menu-item index="/admin/reports/invoices">
              <el-icon><Document /></el-icon>
              <template #title>{{ t('menu.dailyInvoicesReport') }}</template>
            </el-menu-item>
            <el-menu-item index="/admin/reports/unpaid-students">
              <el-icon><List /></el-icon>
              <template #title>{{ t('menu.unpaidStudentsReport') }}</template>
            </el-menu-item>
            <el-menu-item index="/admin/reports/catering">
              <el-icon><Coffee /></el-icon>
              <template #title>{{ t('menu.cateringReport') }}</template>
            </el-menu-item>
          </el-sub-menu>

          <!-- 8. Dashboard (Syn) -->
          <el-sub-menu index="dashboard-menu">
            <template #title>
              <el-icon><DataLine /></el-icon>
              <span>{{ t('menu.dashboard') }}</span>
            </template>
            <el-menu-item index="/admin/dashboard/birthday">
              <el-icon><Calendar /></el-icon>
              <template #title>{{ t('menu.birthdays') }}</template>
            </el-menu-item>
          </el-sub-menu>

          <!-- 9. QR Scanner -->
          <el-menu-item v-if="authStore.can('StudentsManage')" index="/admin/qrcodescanner">
            <el-icon><Aim /></el-icon>
            <template #title>{{ t('menu.qrScanner') }}</template>
          </el-menu-item>

          <!-- 10. Timetable (Sapak tertibi) -->
          <el-menu-item v-if="authStore.can('ReferenceView')" index="/admin/events">
            <el-icon><Calendar /></el-icon>
            <template #title>{{ t('menu.timetable') }}</template>
          </el-menu-item>

          <!-- 11. SMS Merkezi -->
          <el-menu-item v-if="authStore.isAdmin || authStore.isReception" index="/admin/sms">
            <el-icon><ChatDotRound /></el-icon>
            <template #title>SMS Merkezi</template>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
  </aside>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/stores/auth'
import { useAppStore } from '@/stores/app'
import {
  School, Tickets, Calendar, Clock, OfficeBuilding, House, CollectionTag,
  Notebook, UserFilled, User, List, CreditCard, Money, PriceTag, Document, Coffee,
  Compass, Picture, Camera, DocumentChecked, Sunny, EditPen, ChatDotRound, Message,
  DataAnalysis, VideoCamera, View, Coin, Aim, Setting, Key, Upload, PieChart, DataLine,
  Close, Check, Trophy, TrendCharts, CopyDocument
} from '@element-plus/icons-vue'

const route = useRoute()
const router = useRouter()
const { t } = useI18n()
const authStore = useAuthStore()
const appStore = useAppStore()

const activeMenu = computed(() => {
  if (route.path === '/admin/dashboard') {
    return '/admin/dashboard/birthday'
  }
  if (route.path === '/admin/cms/eventregistrations' && route.query.type) {
    return `${route.path}?type=${route.query.type}`
  }
  return route.path
})

function handleMenuSelect(index: string) {
  if (window.innerWidth <= 768) {
    appStore.closeMobileSidebar()
  }
  if (index === 'open-site') {
    window.open('/welcome', '_blank')
    return
  }
  if (!index.startsWith('/admin')) {
    window.location.href = index
    return
  }
  if (route.fullPath === index) {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
    const mainEl = document.querySelector('.admin-content')
    if (mainEl) mainEl.scrollTop = 0
    return
  }
  router.push(index).then(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
  })
}
</script>

<style scoped>
.menu-item-with-badge {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
</style>
